export default __webpack_public_path__ + "static/media/gallery_06.0db9a6b1.jpg";